import * as React from 'react';

import { Input, InputGroup, InputGroupAddon, FormGroup, Label } from 'reactstrap';
import { formatDecimal, getCurrencySymbol } from '../../utils/format';
import { FormInputProps } from 'common/components/form/FormInput';
import { Field, FieldProps } from 'formik';
import { isFieldValid } from 'common/utils/form';
import { FormErrorFeedback } from 'common/components/form/FormErrorFeedback';

export interface FormMoneyInputProps extends FormInputProps {
  currency?: string;
}
export const FormMoneyInput: React.SFC<FormMoneyInputProps> = ({ id, label, name, currency = 'USD', ...rest }) => {
  const symbol = getCurrencySymbol(currency);
  return (
    <Field name={name}>
      {({ field, form }: FieldProps) => {
        const invalid = !isFieldValid(form, name);
        const formattedValue = formatDecimal(field.value);

        return (
          <FormGroup>
            <Label for={id}>{label}</Label>
            <InputGroup>
              <InputGroupAddon addonType="prepend">{symbol}</InputGroupAddon>
              <Input id={id} {...field} value={formattedValue} {...rest} autoComplete="off" invalid={invalid} />
            </InputGroup>
            <FormErrorFeedback field={name} form={form} />
          </FormGroup>
        );
      }}
    </Field>
  );
};



// WEBPACK FOOTER //
// ./src/common/components/form/FormMoneyInput.tsx